import proj1 from "../static/images/mauricioPort.jpg";
import proj2 from "../static/images/UI.jpg";
import proj3 from "../static/images/pro3.png";
import proj4 from "../static/images/block.png";
import proj5 from "../static/images/network_overlay.png";
import proj6 from "../static/images/arp.png";
import proj7 from "../static/images/msd.jpg";

export const ProjectList = [
    {
        name: "Distributed Network Overlay",
        image: proj5,
        id: 5,
        description: "A multithreaded network overlay in Java using socket programming and Dijkstra's routing. Nodes exchange packets concurrently across the overlay with shortest-path forwarding.",
        link: "https://github.com/mauriciog88u1/HW1_ATTEMPT_2.git",
        tools: "Java, Socket Programming",
        skills: "Java, Socket Programming, Dijkstra's Routing, Multithreading, Concurrency",
        github: "https://github.com/mauriciog88u1/HW1_ATTEMPT_2.git"
    },
    {
        name: "Block and Stream Cipher",
        image: proj4,
        id: 4,
        description: "An implementation of a block and stream cipher in C++. From the CLI you encrypt and decrypt files: pass an input file, a key file, and the cipher mode to produce the encrypted output.",
        link: "",
        tools: "C++",
        skills: "C++, Encryption, CLI Tooling, Git",
        github: ""
    },
    {
        name: "ARP Analyzer",
        image: proj6,
        id: 6,
        description: "A Python tool that captures and analyzes ARP packets, mapping source and destination MAC addresses and visualizing the network graph.",
        link: "https://github.com/mauriciog88u1/Arp-Analyzer",
        tools: "Python, pyshark, networkx, matplotlib",
        skills: "Python, Packet Analysis, Network Security, Data Visualization",
        github: "https://github.com/mauriciog88u1/Arp-Analyzer"
    },
    {
        name: "Hadoop Million Songs Dataset Analysis",
        image: proj7,
        id: 7,
        description: "MapReduce analysis of the Million Songs Dataset on a Hadoop cluster.",
        link: "https://github.com/mauriciog88u1/hw3_hadoop.git",
        tools: "Hadoop, Java, Python",
        skills: "Hadoop, MapReduce, Distributed Data Processing, Java, Python",
        github: "https://github.com/mauriciog88u1/hw3_hadoop.git"
    },
    {
        name: "Full Stack Chess Application",
        image: proj2,
        id: 2,
        description: "A full stack chess application where users play against each other. A REST API connects the React front end to the Java Spark back end, a database stores users and game history, and a chess engine validates moves and detects checkmate.",
        link: "/chess",
        tools: "Java Spark, React",
        skills: "Java, React, SQL (MariaDB), REST APIs, Docker, JUnit, Jest, Concurrency",
        github: ""
    },
    {
        name: "Web Based Map Tool",
        image: proj3,
        id: 3,
        description: "A full stack web application for planning trips on an interactive world map. Users can search for locations, build multi-stop itineraries, and optimize routes. Built with a REST API between the React front end and Java Spark back end, with data persisted in MariaDB.",
        link: "",
        tools: "Java Spark, React, MariaDB, Docker, GitHub Actions",
        skills: "Java, JavaScript, React, React Leaflet, SQL (MariaDB), REST APIs, Docker, CI/CD",
        github: ""
    },
    {
        name: "Personal Portfolio Website",
        image: proj1,
        id: 1,
        description: "This site. A terminal-inspired portfolio with light and dark mode and a working command line (press ⌘K).",
        link: "https://mauric10.com",
        tools: "React, Tailwind CSS, shadcn/ui",
        skills: "React, Tailwind CSS, shadcn/ui, JavaScript, Git, Cloudflare",
        github: "https://github.com/mauriciog88u1/mauriciog-portfolio"
    }
];
